import React from 'react';

const FooterYoutubeIcon = (): JSX.Element => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <defs></defs>
    <g id="Layer_2yt" data-name="Layer 2 yt">
      <g>
        <g id="icon_youtube">
          <circle className="cls-1" cx="16" cy="16" r="16" transform="translate(-6.63 16) rotate(-45)" />
          <path className="cls-2" d="M26.12,13.44a4.34,4.34,0,0,0-4.34-4.35H10.52a4.34,4.34,0,0,0-4.34,4.35v5.27a4.34,4.34,0,0,0,4.34,4.35H21.78a4.34,4.34,0,0,0,4.34-4.35ZM19,16.34,14.53,18.8c-.2.11-.37,0-.37-.25V13.49c0-.22.18-.37.37-.25l4.52,2.59A.29.29,0,0,1,19,16.34Z" />
        </g>
      </g>
    </g>
  </svg>
);

export default FooterYoutubeIcon;
